import React from 'react'
import Header from '../Components/Header'
import SideMenu from '../Components/SideMenu'
import dashboard1 from '../Images/dashboard1.png'
import dashboard2 from '../Images/dashboard2.png'
import dashboard3 from '../Images/dashboard3.png'
import dashboard4 from '../Images/dashboard4.png'
import dashboard5 from '../Images/dashboard5.png'
import dashboard6 from '../Images/dashboard6.png'

const Dashboard = () => {
  return (
    <div>
        <div className='mx-4'>
        <Header />
        </div>
        <div className="flex h-screen">
  {/* Sidebar */}
  <SideMenu className="w-1/4 bg-gray-200" />

  {/* Main Content */}
  <div className="flex-1 p-4">
  <div className="border-b pb-2 text-lg font-bold">Dashboard</div>
  
  <div className="grid grid-cols-3 gap-4 mt-4">
  <div className="border shadow-sm rounded">
    <img
      src={dashboard1} // Replace this with your desired image path
      alt="Dashboard Icon"
      className="w-full h-full object-cover rounded cursor-pointer"
    />
  </div>
  <div className="border shadow-sm rounded">
    <img
      src={dashboard2} // Replace this with your desired image path
      alt="Dashboard Icon"
      className="w-full h-full object-cover rounded cursor-pointer"
    />
  </div>
  <div className="border shadow-sm rounded">
    <img
      src={dashboard3} // Replace this with your desired image path
      alt="Dashboard Icon"
      className="w-full h-full object-cover rounded cursor-pointer"
    />
  </div>
  <div className="border shadow-sm rounded">
    <img
      src={dashboard4} // Replace this with your desired image path
      alt="Dashboard Icon"
      className="w-full h-full object-cover rounded cursor-pointer"
    />
  </div>
  <div className="border shadow-sm rounded">
    <img
      src={dashboard5} // Replace this with your desired image path
      alt="Dashboard Icon"
      className="w-full h-full object-cover rounded cursor-pointer"
    />
  </div>
  <div className="border shadow-sm rounded">
    <img
      src={dashboard6} // Replace this with your desired image path
      alt="Dashboard Icon"
      className="w-full h-full object-cover rounded cursor-pointer"
    />
  </div>
  </div>
</div>

</div>

      
    </div>
  )
}

export default Dashboard
